const namespace = 'app';

export { namespace };
